<div class="dropdown text-left">
  <button type="button" class="btn btn-primary rounded bg-gray bg-ultra-light-gray-hover text-nowrap pt-1 pb-2 pl-3 mx-0 pr-2"
    data-toggle="dropdown" (click)="changeArrowDirection()">
    <div class="custom-control custom-checkbox d-inline-block">
      <input class="cursor-pointer custom-control-input" type="checkbox" [appIndeterminate]="checkBoxState">
      <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
      <label class="custom-control-label"></label>
    </div>
    <div class="text-color-brand font-weight-bolder font-size-xs d-inline-block pl-1 pt-1 align-text-top">
      <ng-container i18n="@@app.select_dropdown">SELECT</ng-container>
    </div>
    <div class="iconWidth d-inline-block align-middle pl-1">
      <i class="icon18 se-icon float-right text-color-brand mx-0">{{isOpenedBOMSelect ? 'arrow2_up' : 'arrow2_down'}}</i>
    </div>
  </button>
  <div class="dropdown-menu">
    <a class="dropdown-item cursor-pointer" (click)="selectOption(groupedCheckboxSelections.NONE)">
      @if (checkBoxState === CheckBoxStates.NONE) {
        <div class="tick-width d-inline-block">
          <img class="pr-2" alt="" src="/assets/images/check_small_black_icon.svg">
        </div>
      }
      <ng-container i18n="@@app.select_dropdown_none">None</ng-container>
    </a>
    <a class="dropdown-item cursor-pointer" (click)="selectOption(groupedCheckboxSelections.ALL)">
      @if (checkBoxState === CheckBoxStates.CHECKED) {
        <div class="tick-width d-inline-block">
          <img class="pr-2" alt="" src="/assets/images/check_small_black_icon.svg">
        </div>
      }
      <ng-container i18n="@@app.select_dropdown_all">All</ng-container>
    </a>
    @if (!isDocumentsPage) {
      <a class="dropdown-item cursor-pointer" (click)="selectOption(groupedCheckboxSelections.DIRECT)">
        @if ((checkBoxState === CheckBoxStates.INDETERMINATE) && bomDirectFilterSelected) {
          <div class="tick-width d-inline-block">
            <img class="pr-2" alt="" src="/assets/images/check_small_black_icon.svg">
          </div>
        }
        <ng-container i18n="@@app.direct_delivery">Direct Delivery</ng-container>
      </a>
      <a class="dropdown-item cursor-pointer" (click)="selectOption(groupedCheckboxSelections.PREWIRING)">
        @if ((checkBoxState === CheckBoxStates.INDETERMINATE) && bomPrewiringFilterSelected) {
          <div class="tick-width d-inline-block">
            <img class="pr-2" alt="" src="/assets/images/check_small_black_icon.svg">
          </div>
        }
        <ng-container i18n="@@app.prewiring">Prewiring</ng-container>
      </a>
    }
    @if (isDocumentsPage && !isProjectDocumentsPage) {
      <a class="dropdown-item cursor-pointer" (click)="selectOption(groupedCheckboxSelections.ENCLOSURE_DOCUMENTS)">
        @if ((checkBoxState === CheckBoxStates.INDETERMINATE) && documentsEnclosureSelected) {
          <div class="tick-width d-inline-block">
            <img class="pr-2" alt="" src="/assets/images/check_small_black_icon.svg">
          </div>
        }
        <ng-container i18n="@@app.enclosure_documents">Enclosure Documents</ng-container>
      </a>
      <a class="dropdown-item cursor-pointer" (click)="selectOption(groupedCheckboxSelections.APARTMENT_SPECIFIC)">
        @if ((checkBoxState === CheckBoxStates.INDETERMINATE) && documentsApartmentSpecificSelected) {
          <div class="tick-width d-inline-block">
            <img class="pr-2" alt="" src="/assets/images/check_small_black_icon.svg">
          </div>
        }
        <ng-container i18n="@@app.apartment_specific">Apartment Specific</ng-container>
      </a>
    }
  </div>
</div>
